import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import {
  FiHome, FiFolder, FiCode, FiBriefcase, FiBook, FiAward, FiBookOpen,
  FiMessageSquare, FiUser, FiLogOut, FiMenu, FiX, FiSun, FiMoon,
  FiChevronDown, FiBell, FiSettings
} from 'react-icons/fi';
import { toast } from 'react-toastify';
import './AdminLayout.css';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout, isAuthenticated } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) navigate('/login');
  }, [isAuthenticated, navigate]);

  const menuItems = [
    { path: '/admin', label: 'Dashboard', icon: FiHome },
    { path: '/admin/projects', label: 'Projects', icon: FiFolder },
    { path: '/admin/skills', label: 'Skills', icon: FiCode },
    { path: '/admin/experience', label: 'Experience', icon: FiBriefcase },
    { path: '/admin/education', label: 'Education', icon: FiBook },
    { path: '/admin/certifications', label: 'Certifications', icon: FiAward },
    { path: '/admin/blogs', label: 'Blogs', icon: FiBookOpen },
    { path: '/admin/contacts', label: 'Contacts', icon: FiMessageSquare },
    { path: '/admin/profile', label: 'Profile', icon: FiUser },
  ];

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <Link to="/admin" className="sidebar-logo">
            <span className="logo-icon">&lt;/&gt;</span>
            <span className="logo-text">PortfolioCMS</span>
          </Link>
          <button className="sidebar-close" onClick={() => setSidebarOpen(false)}>
            <FiX />
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <item.icon size={18} />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-link logout-btn" onClick={handleLogout}>
            <FiLogOut size={18} /> <span>Logout</span>
          </button>
        </div>
      </aside>

      <div className="admin-main">
        <header className="admin-header">
          <button className="sidebar-toggle" onClick={() => setSidebarOpen(true)}>
            <FiMenu size={22} />
          </button>
          <div className="header-title">
            <h2>{menuItems.find(m => m.path === location.pathname)?.label || 'Dashboard'}</h2>
          </div>
          <div className="header-actions">
            <button className="theme-toggle" onClick={toggleTheme}>
              {theme === 'light' ? <FiMoon size={18} /> : <FiSun size={18} />}
            </button>
            <div className="header-user">
              <div className="user-avatar">{user?.email?.[0]?.toUpperCase() || 'A'}</div>
              <span className="user-name">{user?.email}</span>
            </div>
            <Link to="/" className="btn btn-outline" style={{ padding: '8px 16px', fontSize: '0.85rem' }}>
              View Site
            </Link>
          </div>
        </header>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>

      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}
    </div>
  );
};

export default AdminLayout;
